import axiosInstance from './axiosInstance';

// Create a new invoice
export const createInvoice = (data) => axiosInstance.post('/invoices', data);

// Get all invoices for the logged-in company
export const getInvoices = (companyId) =>
	axiosInstance.get('/invoices/company', { params: { companyId } });

// Get all invoices for a specific client
export const getInvoicesForClient = (clientId) =>
	axiosInstance.get(`/invoices/client/${clientId}`);

// Get a single invoice by ID
export const getInvoiceById = (id) => axiosInstance.get(`/invoices/${id}`);

// Update an invoice by ID
export const updateInvoice = (id, data) =>
	axiosInstance.put(`/invoices/${id}`, data);

// Delete an invoice by ID
export const deleteInvoice = (id) => axiosInstance.delete(`/invoices/${id}`);

// Send invoice to client as an email
export const emailInvoiceToClient = (
	invoiceId,
	companyName,
	emailAddress,
	invoiceData,
) =>
	axiosInstance.post(`/invoices/${invoiceId}/email`, {
		companyName,
		emailAddress,
		invoiceData,
	});

// Check if invoice analytics data is available for the company
export const checkInvoiceAnalyticsAvailability = () =>
	axiosInstance.get('/invoices/analytics/availability');

// ============ Invoice Goals API Endpoints ============

// Create a new invoice goal
export const createInvoiceGoal = (data) =>
	axiosInstance.post('/invoices/goals', data);

// Get all invoice goals for the logged-in company
export const getInvoiceGoals = () => axiosInstance.get('/invoices/goals');

// Get a single invoice goal by ID
export const getInvoiceGoalById = (id) =>
	axiosInstance.get(`/invoices/goals/${id}`);

// Update an invoice goal by ID
export const updateInvoiceGoal = (id, data) =>
	axiosInstance.put(`/invoices/goals/${id}`, data);

// Delete an invoice goal by ID
export const deleteInvoiceGoal = (id) =>
	axiosInstance.delete(`/invoices/goals/${id}`);
